export default __webpack_public_path__ + "static/char-45-anr-777c679ccee0461b2b45720b348444ca.webp";